module.exports = __webpack_public_path__ + "static/media/ico-pocketcasts.a52f2f35.svg";